import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import { type InputHTMLAttributes, type ReactNode, useId } from 'react';
import './radio-card.scss';
type RadioCardProps = Readonly<{
  id?: string;
  value: string;
  title: ReactNode;
  checked?: boolean;
  disabled?: boolean;
  className?: string;
  inputProps?: Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'id' | 'value' | 'checked'>;
  iconSlot?: ReactNode;
}>;
export const RadioCard = t0 => {
  const $ = _c(21);
  const {
    id,
    title,
    value,
    checked,
    disabled,
    inputProps,
    className,
    iconSlot
  } = t0;
  const generatedId = useId();
  const inputId = id ?? generatedId;
  let t1;
  if ($[0] !== checked || $[1] !== className || $[2] !== disabled) {
    t1 = cn("radio-card", {
      "radio-card--checked": checked,
      "radio-card--disabled": disabled
    }, className);
    $[0] = checked;
    $[1] = className;
    $[2] = disabled;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== title) {
    t2 = <div className="radio-card__title-text">{title}</div>;
    $[4] = title;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== iconSlot) {
    t3 = iconSlot && <div className="radio-card__title-icon">{iconSlot}</div>;
    $[6] = iconSlot;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className="radio-card__title-container">{t2}{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== checked || $[12] !== inputId || $[13] !== inputProps || $[14] !== value) {
    t5 = <input id={inputId} type="radio" value={value} checked={checked} {...inputProps} className="radio-card__input" />;
    $[11] = checked;
    $[12] = inputId;
    $[13] = inputProps;
    $[14] = value;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== inputId || $[17] !== t1 || $[18] !== t4 || $[19] !== t5) {
    t6 = <label className={t1} htmlFor={inputId}>{t4}{t5}</label>;
    $[16] = inputId;
    $[17] = t1;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};